import type { FeedbackTag, ReviewItems } from '../types';

export interface VipSellerInfoState {
    lastActiveStatus: string | null;
    categoriesCount: {
        'For Sale': number;
        Motors: number;
        Property: number;
        Jobs: number;
        Services: number;
        Pets: number;
        Community: number;
    };
    totalAdvertCount: number;
    reviewItemAndFeedbackSummary: ReviewItems;
    filteredSortedFeedbackTags: FeedbackTag[];
}

const initialState: VipSellerInfoState = {
    lastActiveStatus: '',
    categoriesCount: {
        'For Sale': 0,
        Motors: 0,
        Property: 0,
        Jobs: 0,
        Services: 0,
        Pets: 0,
        Community: 0,
    },
    totalAdvertCount: 0,
    reviewItemAndFeedbackSummary: {
        feedbackSummaryList: [
            {
                title: '',
                type: '',
                count: 0,
            },
        ],
        reviewItemList: null,
    },
    filteredSortedFeedbackTags: [],
};

export const UPDATE_VIP_SELLER_INFO = 'UPDATE_VIP_SELLER_INFO';

export const updateVipSellerInfo = (payload?: VipSellerInfoState) => ({
    type: UPDATE_VIP_SELLER_INFO,
    payload,
});

export default (state = initialState, action): VipSellerInfoState =>
    action.type === UPDATE_VIP_SELLER_INFO ? { ...state, ...action.payload } : state;
